/** Translation endpoint calls. A translation is its own post — see @olimhub/shared's Translation type. */
import { apiClient } from '../client'
import type { Language, PaginatedResponse, Translation } from '@olimhub/shared'

export const translationsApi = {
  create: (postId: string, content: string, language: Language, placeText?: string | null) =>
    apiClient
      .post<Translation>(`/posts/${postId}/translations`, { content, language, placeText })
      .then((r) => r.data),

  list: (postId: string, cursor?: string, limit?: number) =>
    apiClient
      .get<PaginatedResponse<Translation>>(`/posts/${postId}/translations`, { params: { cursor, limit } })
      .then((r) => r.data),

  // Canonical post's author hides a bad translation without deleting it.
  hide: (translationId: string) =>
    apiClient.patch(`/translations/${translationId}/hide`).then((r) => r.data),
}
